import {MainTokenStorageHandler} from '../utils';

const BASE_DOMAIN = import.meta.env.VITE_APP_WEBSOCKET_BASE_URL;
const BASE_LIVENESS_DOMAIN = import.meta.env.VITE_APP_LIVENESS_WEBSOCKET_BASE_URL;
const BASE_KIOSKO_DOMAIN = import.meta.env.VITE_APP_KIOSKO_BASE_URL;

class WebSocketService {
  connectWebSocket() {
    const token = MainTokenStorageHandler.getToken();

    const connectionURL = `wss://${BASE_DOMAIN}/?token=${token}`;

    return new WebSocket(connectionURL);
  }

  connectLivenessWebSocket() {
    const connectionURL = `wss://${BASE_LIVENESS_DOMAIN}`;
    return new WebSocket(connectionURL);
  }

  connectKioskoWebSocket() {
    const connectionURL = `ws://${BASE_KIOSKO_DOMAIN}`;
    return new WebSocket(connectionURL);
  }
}

export {WebSocketService};
